import request from '../../../shared/request'

export function getLeadProposals(lead_id) {
  return request(`/lead/proposals/${lead_id}/`)
}

export function getTemporarilySavedLeadProposals(lead_id) {
  return request(`/lead/proposals/${lead_id}/temporarily_saved`)
}

export function getProposalSections(proposal_id) {
  return request(`/lead/proposals/${proposal_id}/section`)
}

export function getProposalItems(proposal_id) {
  return request(`/lead/proposals/${proposal_id}/item`)
}

export function createLeadProposal(payload) {
  return request(`/lead/proposals/${payload.lead_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateLeadProposal(payload) {
  return request(`/lead/proposals/${payload.proposal_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteLeadProposal(payload) {
  return request(`/lead/proposals/${payload.proposal_id}/?leadId=${payload.leadId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/lead/proposals.js